import { Toaster } from 'sonner';
import { useTheme } from '~/lib/stores/theme-store';

/**
 * Theme-aware Toaster — Sonner hardcoded to "dark" before, so light-mode
 * users still got dark toasts. Subscribes to the same theme store the
 * rest of the app uses, so toggling theme flips toasts in lockstep.
 *
 * Anchored bottom-right (FRONT-1098): the top-right corner is where every
 * page header keeps its primary action (PageShell's actions slot), so a
 * toast there sat on top of the very button the user was about to click —
 * and Sonner pauses its auto-dismiss timer while the pointer is over the
 * toast region, so mouse travel toward that button kept re-freezing the
 * toast in place. Bottom-right clears the header and lets the default
 * 4s dismiss actually elapse.
 */
export function ThemedToaster() {
  const { theme } = useTheme();
  return <Toaster theme={theme} position="bottom-right" richColors closeButton />;
}
